import { initSentry } from "@lib/error/sentry/initSentry";
import { denyUrls } from "@lib/error/sentry/rules";
import { viteConfig } from "@lib/utils/viteDefine";

const isProd = window.config.environment === "prod";

initSentry({
  denyUrls,
  release: `entreprise-frontend-v${viteConfig().VITE_PACKAGE_VERSION}`,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: isProd ? 0.2 : 0.5,
});

// Initialize watchdog only in production builds (not local build)
if (import.meta.env.PROD) {
  import("./watchdog").then(({ initWatchdog }) => {
    initWatchdog();
  });
}

window.onload = () => {
  import("./app");
};
